import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";

// Import i18n configuration — must be imported before any component
// that uses useTranslation() so that i18next is initialized first.
import "./i18n";

// Import global styles
import "./styles/globals.css";
import "./styles/animations.css";

// Import root component
import App from "./App";

// Import loading spinner for Suspense fallback
import BookSpinner from "./components/common/BookSpinner";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    'Root element not found. Make sure there is a <div id="root"></div> in your index.html.',
  );
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center bg-background">
          <BookSpinner size="lg" showText />
        </div>
      }
    >
      <App />
    </Suspense>
  </React.StrictMode>,
);
